import React from "react";
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next';


/*
 * https://date-fns.org/v4.1.0/docs/addDays
 * https://www.npmjs.com/package/react-datepicker
 * https://reactdatepicker.com/#example-locale-without-global-variables
 */
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import subDays from "date-fns/subDays"
import addDays from "date-fns/addDays"
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// SemanticUI components
import { Form, FormGroup, FormInput, FormSelect, Container, Header, HeaderContent, Icon, FormField, Grid, GridRow, GridColumn } from 'semantic-ui-react';

// Redux slices
import { setContractData } from "./contractSlice";

// Components
import { mapCurrencyToOptions } from './systemdata';
import Max2ContractSeasonRoomsRooms from "./seasonrooms_rooms";
import Max2ContractSeasonRoomsSeasons from "./seasonrooms_seasons";
import Max2ContractSeasonRoomsPrices from "./seasonrooms_prices";
import Max2ContractSeasonRoomsBoards from "./seasonrooms_boards";

// Styles
import "react-datepicker/dist/react-datepicker.css";
import './contract.css';


registerLocale('de', de);
setDefaultLocale('de');





/**
 * 
 * @param {bool} editMode 
 * @returns 
 */
const Max2ContractSeasonRooms = ({editMode}) => {
  // global State
  const dispatch = useDispatch();
  const Contract    = useSelector((state) => state.contract.data.Contract);
  const systemData  = useSelector((state) => state.app.systemData);

  // i18n
  const { t } = useTranslation();

  // Edit mode?
  const readOnly = editMode ? false : true;

  // Systemdaten
  const derivedOptionsCurrency = React.useMemo(() => {
    if (!systemData || !systemData['icmp006.system_waehrung']) return [];
    const rawData = systemData['icmp006.system_waehrung'] ?? [];
    return mapCurrencyToOptions(rawData);
  }, [systemData]);

  const startDate = Contract.Period.Start ? new Date(Contract.Period.Start) : new Date();
  const endtDate = Contract.Period.End ? new Date(Contract.Period.End) : new Date();


  if (readOnly) {
    return (
      <>
      <Header as='h4'>{t("contract.seasonRooms.general.header")}</Header>
      <Grid>
        <GridRow className='masterdata_ro_row'>
          <GridColumn width={4} className='masterdata_ro_label' textAlign='right'>{t("contract.seasonRooms.general.currencyLabel")}</GridColumn>
          <GridColumn width={12}>{derivedOptionsCurrency.map((curr) => { return curr.value === Contract.Currency ? curr.text : <></> })}</GridColumn>
        </GridRow>
        <GridRow className='masterdata_ro_row'>
          <GridColumn width={4} className='masterdata_ro_label' textAlign='right'>{t("contract.seasonRooms.general.periodFrom")}</GridColumn>
          <GridColumn width={12}>{format(startDate, "dd.MM.yyyy")}</GridColumn>
        </GridRow>
        <GridRow className='masterdata_ro_row'>
          <GridColumn width={4} className='masterdata_ro_label' textAlign='right'>{t("contract.seasonRooms.general.periodTo")}</GridColumn>
          <GridColumn width={12}>{format(endtDate, "dd.MM.yyyy")}</GridColumn>
        </GridRow>
      </Grid>
  
      <br />
      <br />
  
      <Header as='h4'>
        <Icon name='angle right' />
        <HeaderContent>{t('contract.seasonRooms.general.header')}</HeaderContent>
      </Header>
      <Container className="large">
        <Max2ContractSeasonRoomsRooms editMode={editMode} />
      </Container>
  
      <br />
      <br />
  
      <Header as='h4'>
        <Icon name='angle right' />
        <HeaderContent>{t('contract.seasonRooms.sections.seasons')}</HeaderContent>
      </Header>
      <Container className="large">
        <Max2ContractSeasonRoomsSeasons editMode={editMode} />
      </Container>
      
      <br />
      <br />
  
      <Header as='h4'>
        <Icon name='angle right' />
        <HeaderContent>{t('contract.seasonRooms.sections.prices')}</HeaderContent>
      </Header>
      <Container className="large">
        <Max2ContractSeasonRoomsPrices editMode={editMode} />
      </Container>
  
      <br />
      <br />
      
      <Header as='h4'>
        <Icon name='angle right' />
        <HeaderContent>{t('contract.seasonRooms.sections.boards')}</HeaderContent>
      </Header>
      <Container className="large">
        {<Max2ContractSeasonRoomsBoards editMode={editMode} />}
      </Container>
  
      </>
    );
  }


  return (
    <>
    <Header as='h4'>
      <Icon name='angle right' />
      <HeaderContent>{t('contract.seasonRooms.general.header')}</HeaderContent>
    </Header>
    <Container>
      <Form>
        <FormSelect search selection readOnly={readOnly} value={Contract.Currency} label={t('contract.seasonRooms.general.currencyLabel')} options={derivedOptionsCurrency} placeholder={t('contract.seasonRooms.general.currencyPlaceholder')} />
        <FormGroup>
          <FormField>
            <DatePicker
              showWeekNumbers
              selected    = {startDate}
              startDate   = {startDate}
              endDate     = {endtDate}
              dateFormat  = "dd.MM.yyyy"
              placeholder = {t('contract.seasonRooms.general.datePlaceholder')}
              readOnly    = {readOnly}
              onChange    = {(date) => dispatch(setContractData({target: 'Period.Start', value: format(date, "yyyy-MM-dd")}))}
              customInput = {<FormInput label={t('contract.seasonRooms.general.periodFrom')} icon='calendar alternate' iconPosition='left' placeholder={t('contract.seasonRooms.general.datePlaceholder')}/>}
            />
          </FormField>
          <FormField>
            <DatePicker
              showWeekNumbers
              selected    = {endtDate}
              startDate   = {startDate}
              endDate     = {endtDate}
              minDate     = {startDate}
              dateFormat  = "dd.MM.yyyy"
              placeholder = {t('contract.seasonRooms.general.datePlaceholder')}
              readOnly    = {readOnly}
              onChange    = {(date) => dispatch(setContractData({target: 'Period.End', value: format(date, "yyyy-MM-dd")}))}
              customInput = {<FormInput label={t('contract.seasonRooms.general.periodTo')} icon='calendar alternate' iconPosition='left' placeholder={t('contract.seasonRooms.general.datePlaceholder')}/>}
              excludeDateIntervals = {[
                { start: subDays(new Date("1970-01-01"), 5), end: addDays(startDate, 5) },
              ]}
            />
          </FormField>
        </FormGroup>
      </Form>
    </Container>

    <br />
    <br />

    <Header as='h4'>
      <Icon name='angle right' />
      <HeaderContent>{t('contract.seasonRooms.sections.rooms')}</HeaderContent>
    </Header>
    <Container className="large">
      <Max2ContractSeasonRoomsRooms editMode={editMode} />
    </Container>

    <br />
    <br />

    <Header as='h4'>
      <Icon name='angle right' />
      <HeaderContent>{t('contract.seasonRooms.sections.seasons')}</HeaderContent>
    </Header>
    <Container className="large">
      <Max2ContractSeasonRoomsSeasons editMode={editMode} />
    </Container>
    
    <br />
    <br />

    <Header as='h4'>
      <Icon name='angle right' />
      <HeaderContent>{t('contract.seasonRooms.sections.prices')}</HeaderContent>
    </Header>
    <Container className="large">
      <Max2ContractSeasonRoomsPrices editMode={editMode} />
    </Container>

    <br />
    <br />
    
    <Header as='h4'>
      <Icon name='angle right' />
      <HeaderContent>{t('contract.seasonRooms.sections.boards')}</HeaderContent>
    </Header>
    <Container className="large">
      {<Max2ContractSeasonRoomsBoards editMode={editMode} />}
    </Container>

    </>
  );
}

export default Max2ContractSeasonRooms;